import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, FormControlLabel, Switch, Checkbox } from '@mui/material';
import { TextField, Autocomplete } from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { get, set, over } from '@totalsoft/change-tracking-react';
import { onCheckBoxChange } from 'utils/propertyChangeAdapters';
export const AccountStatementGeneralDataComponent = ({
  accountStatement,
  validation,
  saving,
  canWrite,
  bankInputValue,
  handleBankInputChange,
  banksOptions,
  banksLoading

}) => {
  const [t] = useTranslation();

  return (
    <Grid container spacing={4}>

      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          value={(accountStatement.configName |> get) || ''}
          onChange={accountStatement.configName |> set}
          label={t('AccountStatement.ConfigName')}
          error={!isValid(validation.configName)}
          helperText={getErrors(validation.configName)}
          disabled={!canWrite || saving}
          required
        />
      </Grid>      
      <Grid item xs={12} sm={2}>
        <TextField
          fullWidth
          value={(accountStatement.configVersion |> get) || ''}
          label={t('AccountStatement.ConfigVersion')}
          disabled={true}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Autocomplete
          fullWidth
          inputValue={bankInputValue}
          onInputChange={handleBankInputChange}
          value={banksOptions.find(x => x.id === (accountStatement.bankId |> get)) || {id: (accountStatement.bankId |> get), partnerName: (accountStatement.bankPartnerName |> get)}}
          onChange={event => over(accountStatement, prev => ({...prev, bankId: event.id, bankPartnerName: event.partnerName}))}
          label={t("AccountStatement.Bank")}
          valueKey="id"
          labelKey="partnerName"
          options={banksOptions}
          loading={banksLoading}
          disabled={!canWrite || saving}
          componentsProps={{ popper: { style: { width: "fit-content" } } }}
        />
      </Grid>      
      <Grid item xs={12} sm={1}>
        <FormControlLabel
          control={<Switch checked={(accountStatement.activeYN |> get) || false} />}
          onChange={accountStatement.activeYN |> set |> onCheckBoxChange}
          label={t('AccountStatement.ActiveYN')}
          disabled={!canWrite || saving}
          sx={{ marginTop: 2 }}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <FormControlLabel
          control={<Checkbox  checked={(accountStatement.usedByPartner |> get) || false} />}
          label={t('AccountStatement.UsedByPartner')}
          disabled={true}
          sx={{ marginTop: 1 }}
        />
      </Grid>
    </Grid>
  );
};

AccountStatementGeneralDataComponent.propTypes = {
  accountStatement: PropTypes.object.isRequired,
  validation: PropTypes.object.isRequired,
  saving: PropTypes.bool.isRequired,
  canWrite: PropTypes.bool,
  bankInputValue: PropTypes.object,
  handleBankInputChange: PropTypes.func,
  banksOptions: PropTypes.array,
  banksLoading: PropTypes.bool
};

export default AccountStatementGeneralDataComponent;
